export default {
  "404.title": "404 Not Found",
  "404.description": "404 Not Found",
  "404.message1": "お探しのページは見つかりませんでした。",
  "404.message2": "トップページよりお探しください。",
  "404.backToTop": "トップページに戻る",
};
